import { Routes, Route, Navigate } from "react-router-dom";
import RequireAuth from "../features/auth/RequireAuth";
import AdminLayout from "../layouts/AdminLayout";
import LoginPage from "../features/auth/LoginPage";
import StagingProductionPage from "../features/pages/staging/StagingProductionPage";
import MasterPalletePage from "../features/pages/pallete/masterPalletePage";
import MasterRakingPage from "../features/pages/raking/masterRakingPage";
import Dashboard from "../features/pages/dashboard/dashboardPage";

// Dummy pages dulu

function Inventory() {
    return <div className="text-2xl font-semibold">Inventory Page</div>;
}

function Unauthorized() {
    return (
        <div className="flex items-center justify-center h-screen">
            <h1 className="text-3xl text-red-500 font-bold">
                403 - Unauthorized
            </h1>
        </div>
    );
}

function NotFound() {
    return (
        <div className="flex items-center justify-center h-screen">
            <h1 className="text-3xl font-bold">404 - Page Not Found</h1>
        </div>
    );
}

export default function AppRoutes() {
    return (
        <Routes>
            {/* PUBLIC ROUTES */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* PROTECTED ADMIN ROUTES */}
            <Route
                path="/admin"
                element={
                    <RequireAuth role="admin">
                        <AdminLayout />
                    </RequireAuth>
                }
            >
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="palette" element={<MasterPalletePage />} />
                <Route path="raking" element={<MasterRakingPage />} />
                <Route path="datapalete" element={<StagingProductionPage />} />
            </Route>

            {/* FALLBACK */}
            <Route path="*" element={<LoginPage />} />
        </Routes>
    );
}